import React from 'react';

const getUserType = () => sessionStorage.getItem('user_type');

const Authorization = ({ allowed, children }) => {
  const userType = getUserType();
  return allowed.includes(userType) ? children : null;
};

export default Authorization;
